import { render } from "./StaffDatatableTDStaffName.vue?vue&type=template&id=69c32aa5&scoped=true"
import script from "./StaffDatatableTDStaffName.vue?vue&type=script&lang=js"
export * from "./StaffDatatableTDStaffName.vue?vue&type=script&lang=js"

import "./StaffDatatableTDStaffName.vue?vue&type=style&index=0&id=69c32aa5&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c32aa5"]])

export default __exports__